"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const react_1 = __importStar(require("react"));
const assets_1 = require("~/assets");
const Option_1 = __importDefault(require("./Option"));
const Dropdown_scss_1 = __importDefault(require("./Dropdown.scss"));
function Dropdown({ options, defaultLabel, onChange, selectedValue }) {
    var _a;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [selectedItem, setSelectedItem] = (0, react_1.useState)(selectedValue);
    const toggleDropdown = () => setIsOpen(!isOpen);
    const handleItemClick = (value) => {
        setSelectedItem(value);
        onChange(value);
        setIsOpen(false);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: Dropdown_scss_1.default.header, "data-open": isOpen, onClick: toggleDropdown },
            selectedItem ? (_a = options.find((item) => item.value === selectedItem)) === null || _a === void 0 ? void 0 : _a.label : defaultLabel,
            react_1.default.createElement("img", { className: Dropdown_scss_1.default.image, src: isOpen ? assets_1.svgSystemChevronUp : assets_1.svgSystemChevronDown })),
        react_1.default.createElement("div", { className: Dropdown_scss_1.default.body, "data-open": isOpen }, options.map((option) => (react_1.default.createElement(Option_1.default, { key: option.label, value: option.value, label: option.label, selected: option.value === selectedItem, onClick: handleItemClick }))))));
}
exports.default = Dropdown;
